import React from "react";
import Header from "./../Layout/Header";
import PageTitle from "./../Pages/PageTitle";
import UserProfileGeneral from "../component/UserProfileGeneral";
import { useTranslation } from "react-i18next";
import SettingMenu from "../component/SettingMenu";

const Settings = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Header />
      <PageTitle />
      <div className="settings mb-80">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-md-4">
              <SettingMenu />
            </div>
            <div className="col-xl-9 col-md-8">
              <div className="row">
                {/* <UserProfilePhoto profile={profile} />
                  <UserProfileEmail /> */}
                <UserProfileGeneral />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
